import { useEffect, useState } from 'react';
export const TrackrecordInfoTable = ({ trackrecordInfo }) => {

    console.log("Se renderiza el componente TrackrecordInfoTable")

    const [trackrecordInfoReceived, setTrackrecordInfoReceived] = useState([]);
    const [sortDirection, setSortDirection] = useState(null);
    const [fieldToSort, setfieldToSort] = useState(null);

    useEffect(() => {
        // Al entrar, ordenamos por rentabilidad de mayor a menor.
        applySort(trackrecordInfo, 'rentabilidad', 'desc');
    }, []);

    const applySort = (data, field, direction) => {
        const array = [...data];
        array.sort((a, b) => {
            const diff = Number(a[field]) - Number(b[field]);
            return direction === 'asc' ? diff : -diff;
        });

        setfieldToSort(field);
        setSortDirection(direction);
        setTrackrecordInfoReceived(array);
    }

    const sortTrackrecord = (field) => {
        // Primer clic sobre la columna: de mayor a menor. Siguientes clics: alterna.
        const newDirection = (fieldToSort === field && sortDirection === 'desc') ? 'asc' : 'desc';
        applySort(trackrecordInfoReceived, field, newDirection);
    }


    return (
        <>
            <thead>
            <tr>
                <th>
                    <button
                        type="button"
                        className="btn_header">
                    Stock
                    </button>
                </th>
                <th>
                    <button
                        type="button"
                        onClick={() => sortTrackrecord('rentabilidad')}
                        className="btn_header">
                    Return value
                    {fieldToSort === 'rentabilidad' && sortDirection === 'desc' &&  <i className="fa fa-sort-desc" />}
                    {fieldToSort === 'rentabilidad' && sortDirection === 'asc' &&  <i className="fa fa-sort-asc" />}
                    </button>
                </th>
                <th>
                    <button
                        type="button"
                        className="btn_header">
                    Return days
                    </button>
                </th>
            </tr>
            </thead>
            <tbody>
                {undefined != trackrecordInfoReceived && trackrecordInfoReceived.length > 0 && trackrecordInfoReceived.map((stock) => {
                    const list = (
                    <tr key={stock['id_trackrecord']}>
                        <td>{stock['titulo_valor']} </td>
                        <td>{stock['rentabilidad']}%</td>
                        {stock['dias_en_cartera'] == 0 && <td>n/a </td>}
                        {stock['dias_en_cartera'] != 0 && <td>{stock['dias_en_cartera']}</td>}
                    </tr>
                    );
                    return list;
                })}
            </tbody>
        </>
    );
}